module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/student/student.component.css
// module id = ./src/app/student/student.component.css
// module chunks = main